export const trackByID = <T extends { id: string }>(i: number, {id}: T) => id;
export const trackBySID = <T extends { sid: string }>(i: number, {sid: id}: T) => id;
export const trackByIndex = <T extends { index: string }>(i: number, {index: id}: T) => id;
export const trackByUniqueName = <T extends { uniqueName: string }>(i: number, {uniqueName: id}: T) => id;
